import { appServe } from "@/service"
import { useAppStore } from "@/store"
import { toLogin } from "@/utils"
import RewardRoutes from "@/views/Reward/router"
import { omit } from "lodash"
import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "layouts" */ "@/layouts"),
    redirect: { name: "base-home" },
    children: [
      {
        path: "login",
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ "@/views/Login")
      },
      {
        path: "test-login",
        name: "test-login",
        component: () =>
          import(/* webpackChunkName: "login" */ "@/views/Login/TestLogin.vue")
      },
      {
        path: "green-login",
        name: "green-login",
        component: () =>
          import(
            /* webpackChunkName: "green-login" */ "@/views/Login/GreenLogin.vue"
          )
      },
      //首页
      {
        path: "home",
        name: "base-home",
        meta: { depth: 0, keepAlive: true },
        component: () => import("@/views/Home/Home.vue")
      },
      {
        path: "progress",
        name: "BaseProgress",
        meta: { depth: 1, keepAlive: true },
        component: () => import("@/views/Progress/Progress.vue")
      },
      {
        path: "progress/detail",
        name: "BaseProgressDetail",
        meta: { depth: 2 },
        component: () => import("@/views/Progress/Detail.vue")
      },
      {
        path: "message",
        name: "BaseMessage",
        meta: { keepAlive: true },
        component: () => import("@/views/Message/Message.vue")
      },
      {
        path: "message/detail",
        meta: { depth: 1, keepAlive: true },
        name: "BaseMessageDetail",
        component: () => import("@/views/Message/Detail.vue")
      },
      {
        path: "my",
        name: "base-my",
        component: () => import("@/views/My/My.vue")
      },
      {
        path: "my/feedback",
        name: "base-my-feedback",
        component: () => import("@/views/My/FeedBack.vue")
      },
      //首页
      {
        path: "inner",
        name: "inner",
        component: () => import("@/views/Inner/InnerLayout.vue"),
        children: [
          {
            path: "policy",
            name: "inner-policy",
            meta: { title: "人才新政" },
            component: () => import("@/views/Inner/Policy.vue")
          },
          {
            path: "hotline",
            name: "inner-hotline",
            meta: { title: "服务热线" },
            component: () => import("@/views/Inner/HotLine.vue")
          },
          {
            path: "announcement",
            name: "inner-announcement",
            meta: { title: "公示公告" },
            component: () => import("@/views/Inner/Announcement.vue")
          }
          // {
          //   path: "video",
          //   name: "inner-video",
          //   meta: { title: "宣传视频" },
          //   component: () => import("@/views/Inner/Video.vue")
          // }
        ]
      },
      {
        path: "inner/announcement/detail",
        name: "inner-announcement-detail",
        meta: { title: "公示公告" },
        component: () => import("@/views/Inner/AnnoDetails.vue")
      },
      {
        path: "inner/headline",
        name: "inner-headline",
        meta: { title: "资讯" },
        component: () => import("@/views/Inner/Headline.vue")
      },
      {
        path: "inner/applist",
        name: "inner-applist",
        component: () => import("@/views/Inner/AppList.vue")
      },
      {
        path: "/query-qrcode",
        name: "query-qrcode",
        component: () => import("@/views/QueryQrcode/QueryQrcode.vue")
      },
      // 校友录
      {
        path: "alumni",
        component: () => import("@/views/Alumni/Layout"),
        children: [
          {
            path: "",
            redirect: () => {
              return { name: "MyAlumniIndex" }
            }
          },
          {
            path: "my",
            name: "MyAlumniIndex",
            meta: { title: "我的", depth: 1, keepAlive: true },
            component: () =>
              import(/* webpackChunkName: "My" */ "@/views/Alumni/My")
          },
          {
            path: "classmates",
            name: "ClassmatesIndex",
            meta: { title: "校友录", depth: 4, keepAlive: true },
            component: () =>
              import(
                /* webpackChunkName: "Classmates" */ "@/views/Alumni/My/Classmates"
              )
          },
          {
            path: "classmates/info",
            meta: { title: "校友信息", depth: 5 },
            component: () =>
              import(
                /* webpackChunkName: "ClassmatesInfo" */ "@/views/Alumni/My/ClassmatesInfo"
              )
          },
          {
            path: "school",
            name: "SchoolIndex",
            meta: { title: "组织架构", depth: 1, keepAlive: true },
            component: () =>
              import(/* webpackChunkName: "School" */ "@/views/Alumni/School")
          },
          {
            path: "message",
            name: "MessageIndex",
            meta: { title: "消息", depth: 1, keepAlive: true },
            component: () =>
              import(/* webpackChunkName: "Message" */ "@/views/Alumni/Message")
          },
          {
            path: "message/send",
            name: "MessageSend",
            meta: { title: "发消息", depth: 2 },
            component: () =>
              import(
                /* webpackChunkName: "MessageSend" */ "@/views/Alumni/Message/Send"
              )
          },
          {
            path: "info",
            meta: { useInfo: false },
            component: () =>
              import(/* webpackChunkName: "Info" */ "@/views/Alumni/Info")
          },
          {
            path: "search",
            name: "SearchIndex",
            meta: { title: "搜索", depth: 3, keepAlive: true },
            component: () =>
              import(/* webpackChunkName: "Search" */ "@/views/Alumni/Search")
          },
          {
            path: "setting",
            meta: { title: "个人信息", depth: 2 },
            component: () =>
              import(/* webpackChunkName: "Setting" */ "@/views/Alumni/Setting")
          },
          {
            path: "setting/auth",
            meta: { title: "信息授权", depth: 3 },
            component: () =>
              import(
                /* webpackChunkName: "SettingAuth" */ "@/views/Alumni/Setting/Auth"
              )
          },
          {
            path: "invite/create",
            meta: { title: "邀请", depth: 1 },
            component: () =>
              import(
                /* webpackChunkName: "InviteCreate" */ "@/views/Alumni/Invite/Create"
              )
          },
          {
            path: "invite/accept/:code",
            meta: { title: "校友录", depth: 1, useInfo: false },
            component: () =>
              import(
                /* webpackChunkName: "InviteJoin" */ "@/views/Alumni/Invite/Join"
              )
          },
          {
            path: "inner",
            name: "innerLayout",
            component: () => import("../layouts/Menu"),
            children: [
              {
                path: "home",
                name: "home",
                component: () =>
                  import(/* webpackChunkName: "home" */ "@/views/Alumni/Home")
              }
            ]
          }
        ]
      },
      // 共富人才
      {
        path: "gf",
        component: () => import("@/views/Gongfu/Layout"),
        children: [
          {
            path: "",
            redirect: () => ({ name: "GFLog" })
          },
          {
            path: "log",
            name: "GFLog",
            meta: { title: "共富人才", depth: 1, keepAlive: true },
            component: () => import("@/views/Gongfu/Log")
          },
          {
            path: "log/edit",
            name: "GFLogEdit",
            meta: { title: "共富人才", depth: 3, keepAlive: true },
            component: () => import("@/views/Gongfu/Log/edit")
          },
          {
            path: "log/achievement",
            name: "GFLogAchievement",
            meta: { title: "共富人才", depth: 4, keepAlive: true },
            component: () => import("@/views/Gongfu/Log/achievement")
          },
          {
            path: "log/details",
            name: "GFLogDetails",
            meta: { title: "共富人才", depth: 2, keepAlive: true },
            component: () => import("@/views/Gongfu/Log/details")
          },
          {
            path: "liaison",
            name: "GFLiaison",
            meta: { title: "共富人才", depth: 1, keepAlive: true },
            component: () => import("@/views/Gongfu/Liaison")
          }
        ]
      },
      // 商家服务
      {
        path: "merchant",
        component: () => import("@/views/Merchant/Layout"),
        children: [
          {
            path: "",
            redirect: () => ({ name: "MerchantGuide" })
          },
          {
            path: "guide",
            name: "MerchantGuide",
            meta: { title: "身份选择" },
            component: () => import("@/views/Merchant/Guide")
          },
          {
            path: "nav",
            name: "MerchantNav",
            meta: { title: "服务导航", depth: 1, keepAlive: true },
            component: () => import("@/views/Merchant/Nav")
          },
          {
            path: "center",
            name: "MerchantCenter",
            meta: { title: "人才服务", depth: 2, keepAlive: true },
            component: () => import("@/views/Merchant/Center")
          },
          {
            path: "details",
            name: "MerchantDetails",
            meta: { title: "人才服务", depth: 4, keepAlive: true },
            component: () => import("@/views/Merchant/Details")
          },
          {
            path: "verification",
            name: "MerchantVerification",
            meta: { title: "人才服务", depth: 4 },
            component: () => import("@/views/Merchant/Verification")
          },
          {
            path: "operator",
            name: "MerchantOperator",
            meta: { title: "服务中心", depth: 1 },
            component: () => import("@/views/Merchant/Operator")
          },
          {
            path: "operator/statistic",
            name: "MerchantOperatorStatistic",
            meta: { title: "服务中心" },
            component: () => import("@/views/Merchant/Operator/Statistic")
          },
          {
            path: "evaluate",
            name: "MerchantEvaluate",
            meta: { title: "人才服务-评价", depth: 4 },
            component: () => import("@/views/Merchant/Evaluate")
          }
        ]
      },
      // 奖补相关
      RewardRoutes,
      // 子女入学
      {
        path: "childEnrol",
        name: "childEnrol",
        component: () => import("@/views/ChildEnrol/Layout"),
        children: [
          {
            path: "",
            name: "childEnrolPage",
            component: () => import("@/views/ChildEnrol/Guide/Guide.vue")
          },
          {
            path: "apply",
            name: "childEnrolApply",
            meta: { depth: 3, needLogin: true },
            component: () => import("@/views/ChildEnrol/Apply/index.vue")
          }
        ]
      },
      {
        path: "tuitionSubsidies",
        name: "tuitionSubsidiesPage",
        component: () =>
          import("@/views/ChildEnrol/TuitionSubsidies/Guide/Guide.vue")
      },
      {
        path: "tuitionSubsidies/apply",
        name: "tuitionSubsidiesApply",
        meta: { depth: 3, needLogin: true },
        component: () =>
          import("@/views/ChildEnrol/TuitionSubsidies/Apply/index.vue")
      },
      // 嘉宾
      {
        path: "guest",
        name: "guest",
        children: [
          // 嘉宾邀请
          {
            path: "invite",
            name: "guest-invite",
            children: [
              {
                path: ":lang",
                name: "guest-invite-index",
                component: () => import("@/views/Guest/Invite/Index.vue"),
                meta: { title: "嘉宾邀请" }
              },
              {
                path: ":lang/form",
                name: "guest-invite-form",
                component: () => import("@/views/Guest/Invite/Form.vue"),
                meta: { title: "嘉宾邀请", needLogin: true }
              },
              {
                path: ":lang/result",
                name: "guest-invite-result",
                component: () => import("@/views/Guest/Invite/Result.vue"),
                meta: { title: "嘉宾邀请" }
              }
            ]
          },
          // 嘉宾服务
          {
            path: "service",
            name: "guest-service",
            children: [
              {
                path: "",
                name: "guest-service",
                component: () => import("@/views/Guest/Service/Index.vue"),
                meta: { title: "嘉宾服务专区" }
              },
              {
                path: "zone",
                name: "guest-service-zone",
                component: () => import("@/views/Guest/Service/Zone.vue"),
                meta: { title: "嘉宾服务专区" }
              },
              {
                path: "info",
                name: "guest-service-info",
                component: () => import("@/views/Guest/Service/Info.vue"),
                meta: { title: "嘉宾服务专区" }
              },
              {
                path: "result",
                name: "guest-service-result",
                component: () => import("@/views/Guest/Service/Result.vue"),
                meta: { title: "嘉宾服务专区" }
              },
              {
                path: "history",
                name: "guest-service-history",
                component: () => import("@/views/Guest/Service/History.vue"),
                meta: { title: "嘉宾服务专区" }
              }
            ]
          }
        ]
      },
      // 租房补贴
      {
        path: "rentalSubsidies",
        name: "rentalSubsidies",
        children: [
          {
            path: "",
            name: "rentalSubsidiesGuide",
            component: () => import("@/views/RentalSubsidies/Guide.vue")
          },
          {
            path: "apply",
            name: "rentalSubsidiesApply",
            meta: { depth: 3, needLogin: true },
            component: () => import("@/views/RentalSubsidies/Apply/index.vue")
          }
        ]
      },
      // 人才认定
      {
        path: "talentDetermine",
        name: "talentDetermine",
        meta: { needLogin: true },
        redirect: { name: "talentDetermineChannel" },
        children: [
          {
            path: "channel",
            name: "talentDetermineChannel",
            component: () => import("@/views/TalentDetermine/Channel.vue")
          },
          {
            path: "illustrate",
            name: "talentDetermineIllustrate",
            component: () => import("@/views/TalentDetermine/Illustrate.vue")
          },
          {
            path: "result",
            name: "talentDetermineResult",
            component: () => import("@/views/TalentDetermine/Result.vue")
          },
          {
            path: "apply",
            name: "talentDetermineApply",
            meta: { depth: 3 },
            component: () => import("@/views/TalentDetermine/Apply/index.vue")
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_PUBLIC_PATH),
  routes,
  scrollBehavior(to, from, savedPosition) {
    const appStore = useAppStore()
    if (appStore.cachedViews.includes(to.name)) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 进入 校友录入、邀请页 不需要获取用户信息
router.beforeEach(async (to, from, next) => {
  const appStore = useAppStore()
  const { title = process.env.VUE_APP_TITLE, needLogin } = to.meta
  document.title = title

  // 返回时清除 上个页面缓存
  let toDepth = to.meta.depth || 0
  let fromDepth = from.meta.depth || 0
  if (toDepth <= fromDepth) {
    if (from.meta.keepAlive) {
      appStore.delCachedView(from.name)
    }
  }
  if (to.meta.keepAlive) {
    appStore.addCachedView(to.name)
  }

  // 登录校验，对需登录页面拦截后 若获得参数先保存token 否则会无限循环登录
  // 1. 获取 token、rcId
  const { query } = to
  const { token, rcId, type, t } = query
  if (token) {
    // 人才之家token换取jwt token
    const res = await appServe.authRczjQuery({ token })
    if (res.success) {
      appStore.saveLoginKey({ token: res.data })
      to.query = omit(to.query, ["token"])
      next({ ...to, replace: true })
    }
  } else if (t) {
    appStore.saveLoginKey({ token: window.atob(t) })
    to.query = omit(to.query, ["t"])
    next({ ...to, replace: true })
  } else {
    if (needLogin && !appStore.isLogged) {
      toLogin()
    } else {
      next()
    }
  }
})

export default router
